<span *ngIf="errorFlg != false">{{message}}</span>
